const TitleBlockView = ({ properties, metadata, data }) => {
  return (
    <h1
      className="documentFirstHeading"
      style={data?.alignment ? { textAlign: data?.alignment } : {}}
    >
      {(metadata || properties)['title'] || ''}
    </h1>
  );
};

export default TitleBlockView;
